module.exports = __webpack_public_path__ + "static/img/personOne.b136468.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/welcome/personOne.png
// module id = JW0X
// module chunks = 1